export default class WhatsAppService {
  constructor({ host, accountId }) {
    this.host = host
    this.accountId = accountId
  }

  createCallback(params, callback) {
    let url = `${this.host}/accounts/${this.accountId}/genesys-callbacks`

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    }).then(callback)
  }
}
